import { render, staticRenderFns } from "./store-table.vue?vue&type=template&id=050219d1&scoped=true&"
import script from "./store-table.vue?vue&type=script&lang=js&"
export * from "./store-table.vue?vue&type=script&lang=js&"
import style0 from "./store-table.vue?vue&type=style&index=0&id=050219d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050219d1",
  null
  
)

export default component.exports